// Web module: vulnerabilities (lane L8). Drata Vulnerability Monitoring page and the finding SLA tab.
import { lazyComponent } from '../../lib/lazy'
import type { WebModule } from '../../lib/modules'

export const module: WebModule = {
  routes: [],
  entityOverrides: {
    vulnerability: {
      ListPage: lazyComponent(() => import('./VulnerabilitiesPage'), 'VulnerabilitiesPage'),
      detailTabs: [
        {
          id: 'sla',
          label: 'SLA',
          order: 15,
          component: lazyComponent(() => import('./VulnerabilityTabs'), 'VulnerabilitySlaTab'),
        },
      ],
    },
  },
}
